/**
 * The pill showing how many of something a trigger stands for, sitting inside
 * it. What gets counted is the caller's call: the filter chips count the
 * filters currently applied, the automations button counts rules whether or
 * not they are running.
 *
 * Lives here rather than beside its first caller because the same markup existed
 * in three places across two layers: `TrackersToolbar`, `AutomationsButton` and
 * `FilterChipPopover`. Anything below `shared` is unreachable from `shared` under
 * the FSD import direction, so this is the only layer that collapses all three.
 *
 * It is not a Tessra `Badge`: no `Badge` variant paints `bg-primary`, and
 * adopting one would change the colour, which is a design call rather than a
 * refactor.
 */
interface CountBadgeProps {
  count: number;
}

export function CountBadge({ count }: CountBadgeProps) {
  if (count <= 0) return null;

  return (
    <span className="ml-0.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1.5 text-xs font-semibold text-primary-foreground">
      {count}
    </span>
  );
}
